import {
  ServiceLevelVolumeOverTimeRequestSchema,
  ServiceLevelVolumeOverTimeResponseSchema,
} from "@redotech/redo-model/fulfillments/metrics";

export const getServiceLevelVolumeOverTime = {
  name: "getServiceLevelVolumeOverTime" as const,
  input: ServiceLevelVolumeOverTimeRequestSchema,
  output: ServiceLevelVolumeOverTimeResponseSchema,
};
